import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { testingService } from '../../services/testingService';

// Async thunks
export const analyzeEmail = createAsyncThunk(
  'testing/analyzeEmail',
  async (emailData, { rejectWithValue }) => {
    try {
      const response = await testingService.analyzeEmail(emailData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createTestAction = createAsyncThunk(
  'testing/createTestAction',
  async (actionData, { rejectWithValue }) => {
    try {
      const response = await testingService.createTestAction(actionData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const testingSlice = createSlice({
  name: 'testing',
  initialState: {
    emailInput: {
      from: '',
      to: '',
      subject: '',
      date: new Date().toISOString().split('T')[0],
      body: '',
      additionalContext: ''
    },
    analysisResults: null,
    dryRunMode: testingService.getDryRunMode(),
    loading: false,
    error: null
  },
  reducers: {
    updateEmailInput: (state, action) => {
      state.emailInput = { ...state.emailInput, ...action.payload };
    },
    clearEmailInput: (state) => {
      state.emailInput = {
        from: '',
        to: '',
        subject: '',
        date: new Date().toISOString().split('T')[0],
        body: '',
        additionalContext: ''
      };
      state.analysisResults = null;
    },
    toggleDryRunMode: (state) => {
      state.dryRunMode = !state.dryRunMode;
      testingService.setDryRunMode(state.dryRunMode);
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Analyze email
      .addCase(analyzeEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(analyzeEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.analysisResults = action.payload;
      })
      .addCase(analyzeEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create test action
      .addCase(createTestAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTestAction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createTestAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { updateEmailInput, clearEmailInput, toggleDryRunMode, clearError } = testingSlice.actions;
export default testingSlice.reducer;
